<template>
  <div>
    <h1>Aprobación de siniestros</h1>

    <status-filter @change="getpackages" :showCostomer="true" :auxselected="auxselected"></status-filter>

    <table-actions
      :tableHeaders="headers"
      :tableData="packages"
      :title="title"
      :showSelect="false"
      :showSubSelect="showSubSelect"
      :showSubTable="true"
      :hasActions="true"
      :subTableHeaders="subtableHeaders"
      @subSelected="onSubSelected"
      @saveSubSelect="saveSubSelect"
      @downloadProceedings="downloadProceedings"
    ></table-actions>

    <DialogNotSinister
      :showDialog="dialog"
      @CloseDialog="CloseDialog"
      :sinisterNotSelected="sinisterNotSelected"
      @sendSinisterData="sendSinisterData"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ExtranetService from "../../services/extranet";

import StatusFilter from "./StatusFilter";
import TableActions from "./TableActions";

import DialogNotSinister from "./DialogNotSinister";
import assetURL from "@/utils/assetURL";
import downloadFile from "@/utils/downloadFile";

export default {
  name: "PackageTracking",
  components: { StatusFilter, TableActions, DialogNotSinister },
  data() {
    return {
      packages: [],
      status: "redy-for-custom",
      subtableHeaders: [
        { text: "Número de siniestro", value: "sinisterNumber" },
        { text: "Número de requisición", value: "requisitionNumber" },
        { text: "Cliente", value: "highway" },
        { text: "Total", value: "total" },
      ],
      idPackage: null,
      allSinister: [],
      sinisterSelected: [],
      sinisterNotSelected: [],
      dialog: false,
      rejected: [],
      approvedSinisters: [],
      dataSinister: {},
      notCancel: false,
      auxselected: null,
      valueStatus: null,
    };
  },
  computed: {
    headers() {
      if (this.status == "redy-for-custom") {
        return [
          { text: "Folio", value: "folio" },
          { text: "Estatus", value: "name" },
          { text: "Fecha de envío", value: "addDate" },
          { text: "Tiempo transcurrido", value: "validationDate" },
          { text: "Siniestros", value: "sinisters" },
          { text: "Total", value: "total" },
        ];
      }
      return [
        { text: "Folio", value: "folio" },
        { text: "Estatus", value: "name" },
        { text: "Fecha de envío", value: "addDate" },
        { text: "Fecha de autorización", value: "validationDate" },
        { text: "Días transcurridos", value: "validationTime" },
        { text: "Siniestros", value: "sinisters" },
        { text: "Total", value: "total" },
      ];
    },
    showSubSelect() {
      if (this.status == "redy-for-custom") {
        return true;
      }
      return false;
    },
    title() {
      if (this.status == "redy-for-custom") {
        return "Paquetes para aprobar";
      }
      return "Paquetes autorizados";
    },
  },
  mounted() {
    ExtranetService.fetchCostomerpackege().then((response) => {
      this.packages = response;
    });
  },
  methods: {
    getpackages(value) {
      this.status = value.status;
      this.valueStatus = value;
      ExtranetService.fetchCostomerpackege(this.valueStatus).then(
        (response) => {
          this.packages = response;
        }
      );
    },
    onSubSelected(subSelected) {
      this.sinisterSelected = subSelected;
    },
    saveSubSelect(id, relatedAffected) {
      this.sinisterNotSelected = [];
      this.idPackage = id;
      this.allSinister = relatedAffected;
      this.approvedSinisters = this.groupSelectedSinister();
      this.dataSinister = {
        package: this.idPackage,
        approved_sinisters: this.approvedSinisters,
        rejected_sinisters: [],
      };
      this.checkSinister();
      if (this.sinisterNotSelected.length > 0) {
        this.dialog = true;
      } else {
        this.sendSinister(this.dataSinister);
      }
    },
    sendSinister(dataSinister) {
      this.getpackages(this.valueStatus);
      ExtranetService.sendApprovedPackage(dataSinister)
        .then((response) => {
          this.$alertMessage({
            title: "Enviado",
            text: `Paquete aprobado enviado: ${response.data.message}`,
          });
          this.auxselected = "authorized";
          this.alertLoading();
        })
        .catch(this.$fireErrorResponse);
      this.auxselected = null;
    },
    groupSelectedSinister() {
      const approved = [];
      for (let i = 0; i < this.sinisterSelected.length; i++) {
        approved[i] = this.sinisterSelected[i].id;
      }
      return approved;
    },
    checkSinister() {
      let ban = 0;
      for (const item of this.allSinister) {
        for (const toItem of this.sinisterSelected) {
          if (item.sinisterId === toItem.sinisterId) {
            ban = 1;
          }
        }
        if (ban === 0) {
          this.sinisterNotSelected.push({
            sinister: item,
            message: null,
          });
        }
        ban = 0;
      }
    },
    CloseDialog() {
      const resultado = !this.dialog
        ? (this.dialog = true)
        : (this.dialog = false);
      return resultado;
    },
    sendSinisterData(rejectedSinisters) {
      this.rejected = rejectedSinisters;
      this.dialog = false;
      this.notCancel = true;
    },
    alertLoading() {
      let timerInterval;
      Swal.fire({
        title: "Cargando vista Antorizados",
        html: "Se cierra en <b></b> millisegundos.",
        timer: 1500,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            const content = Swal.getContent();
            if (content) {
              const b = content.querySelector("b");
              if (b) {
                b.textContent = Swal.getTimerLeft();
              }
            }
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      });
    },
    downloadProceedings(id, folio) {
      const prefix = process.env.NODE_ENV === "production" ? "" : "/api/v1";
      const url = assetURL(`${prefix}/extranet/package/zip/${id}/`);
      downloadFile(url, `${folio}-expediente.zip`)
        .then()
        .catch(() => {
          this.$$alertMessage({ title: "Error al descargar paquete" });
        });
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        if (this.rejected.length > 0 && this.notCancel) {
          this.approvedSinisters = this.groupSelectedSinister();
          this.dataSinister.rejected_sinisters = this.rejected;
          this.sendSinister(this.dataSinister);
          this.notCancel = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  z-index: unset;
}
</style>


// WEBPACK FOOTER //
// src/pages/extranet/CustomerPackage.vue